import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/AutopromoContent.scss';
import AutopromoButton from 'src/components/AutopromoBtn';
import AutopromoButtonImage from 'src/components/AutopromoBtnImg';


const AutopromoContent = ({
  title,
  subtitle,
  buttons,
  containerAlign
}) => (
  <React.Fragment>
    <h3 styleName="autopromo-title">
      { title }
    </h3>
    { !!subtitle && <p styleName="autopromo-subtitle">{ subtitle }</p> }
    {
      buttons.map(({
        img, text, altText, lightBgColor, url, linkTitle
      }) => (
        // eslint-disable-next-line multiline-ternary
        img.length > 0
          ? (
            // eslint-disable-next-line multiline-ternary
            <AutopromoButtonImage
              key={ url }
              altText={ altText }
              containerAlign={ containerAlign }
              img={ img }
              linkTitle={ linkTitle }
              url={ url }
            />
          )
          : (
            <AutopromoButton
              key={ url }
              containerAlign={ containerAlign }
              lightBgColor={ lightBgColor }
              linkTitle={ linkTitle }
              smallerBtns={ buttons.length > 1 }
              text={ text }
              url={ url }
            />
          )
      ))
    }
  </React.Fragment>
);

AutopromoContent.propTypes = {
  buttons: PropTypes.arrayOf(Object).isRequired,
  containerAlign: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default AutopromoContent;
